exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-nav-bar{z-index:100!important}.van-nav-bar .van-icon{color:#00d8a0!important}", ""]);

// exports
